import request from "@/helper/request";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getPoints() {
    return request({
        url: 'api/auth/points',
        method: 'get'
    })
}